import { t } from "@lingui/macro";

import { EventCardWrapper_Event$key } from "@/screens/Home/components/FeaturedEvents/EventsList/components/__generated__/EventCardWrapper_Event.graphql";
import { PopUpModal } from "@whoosh/design-system/src/components/overlay/PopUpModal";
import { VStack } from "@whoosh/design-system/src/components/primitive";

import { EventCardWrapper } from "../../../Home/components/FeaturedEvents/EventsList/components/EventCardWrapper";

type EventDetailSeriesSessionsModalProps<
  T extends EventCardWrapper_Event$key | null
> = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  events: T[];
};

export const EventDetailSeriesSessionsModal = <
  T extends EventCardWrapper_Event$key | null
>({
  isOpen,
  onClose,
  title,
  events,
}: EventDetailSeriesSessionsModalProps<T>) => {
  return (
    <PopUpModal
      isOpen={isOpen}
      onClose={onClose}
      upperTitle={title}
      isConfirmVisible={false}
      cancelText={t`Close`}
      content={
        <VStack gap={4}>
          {events.map((event, index) => (
            <EventCardWrapper
              key={index}
              fullWidth
              eventCardWrapperRef={event}
            />
          ))}
        </VStack>
      }
    ></PopUpModal>
  );
};
